module.exports = __webpack_public_path__ + "static/media/tableau.148cae2e.svg";